const stream = require('stream')
const Minio = require('minio')
let client = null
let bucketName = null
let noAuthClient =null
let noAuthBucketName =null


import path from 'path'
import { getMinioUrl, getSts,getMallSts } from '@/api/common'

function toBlob(base64Data) {
  let byteString = base64Data
  if (base64Data.split(',')[0].indexOf('base64') >= 0) {
    byteString = window.atob(base64Data.split(',')[1]) // base64 解码
  } else {
    byteString = unescape(base64Data.split(',')[1])
  }
  // 获取文件类型
  const mimeString = base64Data.split(';')[0].split(':')[1] // mime类型

  // ArrayBuffer 对象用来表示通用的、固定长度的原始二进制数据缓冲区
  // let arrayBuffer = new ArrayBuffer(byteString.length) // 创建缓冲数组
  // let uintArr = new Uint8Array(arrayBuffer) // 创建视图

  const uintArr = new Uint8Array(byteString.length) // 创建视图

  for (let i = 0; i < byteString.length; i++) {
    uintArr[i] = byteString.charCodeAt(i)
  }
  // 生成blob
  const blob = new Blob([uintArr], {
    type: mimeString
  })
  // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
  return blob
}

function getUUID(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []; var i
  radix = radix || chars.length
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    var r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

function toUpload(storeAs, file, fn, errfn) {
  const mineType = file.type
  const fileSize = file.size
  const reader = new FileReader()
  reader.readAsDataURL(file)
  console.log(reader)
  reader.onloadend = function(e) {
    const dataurl = e.target.result
    const blob = toBlob(dataurl)
    const reader2 = new FileReader()
    reader2.readAsArrayBuffer(blob)
    reader2.onload = function(ex) {
      const bufferStream = new stream.PassThrough()
      bufferStream.end(Buffer.from(ex.target.result))
      client.putObject(bucketName, storeAs, bufferStream, fileSize, mineType, (err, etag) => {
        if (err) {
          console.log(err)
          errfn()
        } else {
          fn(storeAs)
        }
      })
    }
  }
  // var policy = client.newPostPolicy()
  // var expires = new Date();
  // policy.setBucket(bucketName)
  // policy.setKey(storeAs)
  // expires.setSeconds(60 * 60)
  // policy.setExpires(expires)
  // policy.setContentLengthRange(1, 1024 * 1024 * 1024);
  // console.log('创建minio策略 ====>', policy)
  // client.presignedPostPolicy(policy, (err, data) => {
  //   console.log(err, data);
  //   uni.uploadFile({
  //     url: data.postURL,
  //     filePath: file.url,
  //     name: 'file', // 必须填file。
  //     formData: data.formData,
  //     success: (res) => {
  //       if (res.statusCode === 204) {
  //         //console.log('上传成功', res);
  //         //fn(vm.$$setting.OSSUrl + '/' + newFilename);
  //         vm.$$api_common_getMinioUrl({
  //           data: { path: newFilename },
  //           fn: data => {
  //             fn(data);
  //           }
  //         })
  //       }
  //     },
  //     fail: err => {
  //       console.log('上传失败', err);
  //       errfn(err);
  //     }
  //   });
  // })
}

export function upload(file, fn, errfn, prefix, dir) {
  let storeAs = 'jbdl'
  if (dir && dir != '') {
    storeAs = dir
  }
  let newFilename = getUUID(16, 10) + path.extname(file.name)
  if (prefix && prefix != '') {
    newFilename = prefix + '-' + newFilename
  }
  storeAs += '/' + newFilename
  if (!client) {
    getSts().then(data => {
      client = new Minio.Client({
        endPoint: process.env.VUE_APP_OSS,
        // port: 80,
        accessKey: data.accessKeyId,
        secretKey: data.accessKeySecret,
        sessionToken: data.securityToken,
        region: data.region,
        useSSL: true
      })
      bucketName = data.bucket
      toUpload(storeAs, file, fn, errfn)
    }).catch(err => {
      console.log(err)
      errfn(err)
    })
  } else {
    toUpload(storeAs, file, fn, errfn)
  }
}

export function getUrl(url, fn) {
  if (!client) {
    getSts().then(data => {
      client = new Minio.Client({
        endPoint: process.env.VUE_APP_OSS,
        // port: 80,
        accessKey: data.accessKeyId,
        secretKey: data.accessKeySecret,
        sessionToken: data.securityToken,
        region: data.region,
        useSSL: true
      })
      bucketName = data.bucket
      client.presignedGetObject(bucketName, url, 24 * 60 * 60, (err, presignedUrl) => {
        if (err) {
          console.log(err)
          return null
        } else {
          return fn(presignedUrl)
        }
      })
    }).catch(err => {
      console.log(err)
    })
  } else {
    client.presignedGetObject(bucketName, url, 24 * 60 * 60, (err, presignedUrl) => {
      if (err) {
        console.log(err)
        return null
      } else {
        return fn(presignedUrl)
      }
    })
  }
}

export function noAuthUpload(file, fn, errfn, prefix, dir) {
  let storeAs = 'jbdl'
  if (dir && dir != '') {
    storeAs = dir
  }
  let newFilename = getUUID(16, 10) + path.extname(file.name)
  if (prefix && prefix != '') {
    newFilename = prefix + '-' + newFilename
  }
  storeAs += '/' + newFilename
  if (!noAuthClient) {
    getMallSts().then(data => {
      noAuthClient = new Minio.Client({
        endPoint: process.env.VUE_APP_OSS,
        // port: 80,
        accessKey: data.accessKeyId,
        secretKey: data.accessKeySecret,
        sessionToken: data.securityToken,
        region: data.region,
        useSSL: true
      })
      noAuthBucketName = data.bucket
      noAuthToUpload(storeAs, file, fn, errfn)
    }).catch(err => {
      console.log(err)
      errfn(err)
    })
  } else {
    noAuthToUpload(storeAs, file, fn, errfn)
  }
}

function noAuthToUpload(storeAs, file, fn, errfn) {
  const mineType = file.type
  const fileSize = file.size
  const reader = new FileReader()
  reader.readAsDataURL(file)
  console.log(reader)
  reader.onloadend = function(e) {
    const dataurl = e.target.result
    const blob = toBlob(dataurl)
    const reader2 = new FileReader()
    reader2.readAsArrayBuffer(blob)
    reader2.onload = function(ex) {
      const bufferStream = new stream.PassThrough()
      bufferStream.end(Buffer.from(ex.target.result))
      noAuthClient.putObject(noAuthBucketName, storeAs, bufferStream, fileSize, mineType, (err, etag) => {
        if (err) {
          console.log(err)
          errfn()
        } else {
          fn('https://'+process.env.VUE_APP_OSS+'/'+noAuthBucketName+'/'+storeAs)
        }
      })
    }
  }
 
}
